/**
 * Class Name Utility
 *
 * Combines clsx and tailwind-merge for conditional class names
 * that properly handle Tailwind CSS class conflicts.
 */

import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combines class names with Tailwind conflict resolution
 *
 * @example
 * cn('px-2 py-1', condition && 'px-4', 'text-sm')
 * // => 'py-1 px-4 text-sm' (px-2 is overridden by px-4)
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
